import {SiteService} from "./site.service";
import {Component} from "@angular/core";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {UploaderDialogResult} from "../uploader-wrapper/uploader-dialog.model";
import {ConfirmDialogService} from "../confirm-dialog/confirm-dialog-service";
import {contactTypes} from "../types/contact";
import {handleErrors} from "../misc/handle-errors.decorator";
import {SiteDetailModel, siteDetailModelFactory} from "./site-detail.model";
import {ContactService} from "../contact/contact.service";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {SelectItsmContactDialogComponent} from "../workflow/project/select-itsm-contact-dialog.component";
import {ContactModel} from "../contact/contact.model";
import { Query } from "../graphql/query-constant";
import { HasuraGraphqlService } from "../graphql/hasura-graphql-service";
import _ = require("lodash");

@Component({
  selector: "project",
  templateUrl: "./site-show.template.pug",
  providers: [
    SiteService,
    ConfirmDialogService,
    ContactService,
    HasuraGraphqlService,
  ],
})

export class SiteComponent extends RouteHelper {
  error: Error;
  id: string;
  site: SiteDetailModel = siteDetailModelFactory();
  contactTypes: any[] = contactTypes;
  hasContacts: boolean = false;
  itsmSiteContactsWithItsmId: ContactModel[];
  itsmSiteContacts: ContactModel[] = [];
  itsmSiteContactsMap: any;
  paramsMap: RouteMapping[] = [
    {fieldName: "id", paramName: "id"} as RouteMapping,
  ];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private siteService: SiteService,
    public confirmDialogService: ConfirmDialogService,
    private dialogService: DialogService,
    private contactService: ContactService,
    private hasuraGqlService: HasuraGraphqlService,
  ) {
    super();
  }

  @handleErrors()
  async loadData() {
    this.site = await this.siteService.getSiteById(this.id);
    this.hasContacts = this.contactTypes.some(type => this.site[type.field]);
    this.loadItsmAddresses();
  }

  updateItsmContactMapsHelper() {
    this.itsmSiteContacts.sort((a, b) => {
      if ((a.emailAddress || "").toLowerCase() > (b.emailAddress || "").toLowerCase()) return 1;
      return -1;
    });
    this.itsmSiteContactsMap = this.itsmSiteContacts.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    this.itsmSiteContactsWithItsmId = this.itsmSiteContacts.filter(it => !!it.itsmContactId);
  }

  async loadItsmAddresses() {
    // REQUIRES - this.projectId to be set
    // Must be called before the main call to retrieve the project
    Query.GLOBAL_OPP_ID.variables.projectId = this.site.projectId;
    const contactParams = {
      projectId: this.site.projectId,
      uiAction: "SITE-CONTACT",
      queryType: "Global-Deal",
      query: Query.GLOBAL_OPP_ID,
    };
    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(contactParams)
    let contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
      contacts.forEach(item => item.name = `${item.firstName} ${item.lastName}`);
      contacts = _.uniqBy(contacts, "itsmContactId");
      const itsmSiteContacts = contacts.filter((_contact) => {
        if (_contact.resellerCustomerId && _contact.related_account_ids &&
          _contact.related_account_ids.find(rc => rc === _contact.resellerCustomerId)) {
          return _contact;
        }
      });
    this.itsmSiteContacts = itsmSiteContacts && itsmSiteContacts.length ? itsmSiteContacts : contacts;
    //const itsmSiteContacts = await this.siteService.getItsmContacts(this.site.id);
    this.itsmSiteContacts = itsmSiteContacts;
    this.updateItsmContactMapsHelper();
  }

  navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["site"], {queryParams, skipLocationChange});
  }

  importContactsClosed(event: any): void {
    const result = event["value"] as UploaderDialogResult;
    if (result.responses.length) {
      this.loadData();
    }
  }

  @handleErrors()
  async editSiteContact(type: string, selectedTmcContactId = "") {
    const allowCreate = false;
    const requireBpId = false;
    const modalResults = await (SelectItsmContactDialogComponent.showContactModal(
      this.dialogService,
      {
        projectId: this.site.projectId,
        contactService: this.contactService,
        allowCreate,
        requireBpId,
        selectedTmcContactId,
        itsmContacts: this.itsmSiteContactsWithItsmId,
      },
    ));

    if (modalResults && modalResults.changed) {
      const foundContact = this.itsmSiteContacts.find(it => it.id === modalResults.selectedContactId);
      if (
        allowCreate &&
        !foundContact &&
        modalResults.createdContact &&
        modalResults.createdContact.id &&
        modalResults.createdContact.itsmContactId
      ) {
        // Update our list of contacts to include the newly created contact
        this.itsmSiteContacts.push(modalResults.createdContact);
        this.updateItsmContactMapsHelper();
        this.site[type] = modalResults.selectedContactId;
      } else if (foundContact) {
        this.site[type] = this.itsmSiteContactsWithItsmId.find(x => x.id === modalResults.selectedContactId);
      } else {
        this.error = new Error("Selected contact not recognized");
      }
      this.siteService.saveSite(this.site).then(res => console.log("resp", res));
    }
  }

  @handleErrors()
  async remove() {
    let warning = "";
    if (this.site.plannedDevices || this.site.orderCount || this.site.deploymentCount) {
      warning = ` ${this.site.plannedDevices} asset(s), ${this.site.orderCount} order(s) 
      and ${this.site.deploymentCount} deployment(s) will be deleted.`;
    }

    const result = await this.confirmDialogService.confirm(
      "Confirm",
      `Are you sure you want to delete this site?${warning}`,
    );

    if (result) {
      this.error = undefined;
      this.siteService.remove(this.site.id)
        .then(
          () => {
            this.router.navigate(["/sites"], {queryParams: {projectId: this.site.projectId}});
          },
          (error) => {
            this.error = error;
            window.scrollTo(0, 0);
          },
        );
    }
  }
}
